import { render, staticRenderFns } from "./singlePlayer.vue?vue&type=template&id=3a037938&scoped=true"
import script from "./singlePlayer.vue?vue&type=script&lang=js"
export * from "./singlePlayer.vue?vue&type=script&lang=js"
import style0 from "./singlePlayer.vue?vue&type=style&index=0&id=3a037938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a037938",
  null
  
)

export default component.exports